import axios from 'axios';

let api_url = null;
let instance = null;

const hostname = window && window.location && window.location.hostname;


if (hostname === "assessment.agilebrain.com") {
    api_url = "https://app.agilebrain.com";
    instance = axios.create({
        baseURL: `${api_url}/flex360api/`
    });
} else if (hostname === "assessment2.agilebrain.com") {
    api_url = "https://app.agilebrain.com";
    instance = axios.create({
        baseURL: `${api_url}/flex360api2/`
    });
} else if (hostname === "assessment3.agilebrain.com") {
    api_url = "https://app.agilebrain.com";
    instance = axios.create({
        baseURL: `${api_url}/flex360api3/`
    });
} else if (hostname === "assessment4.agilebrain.com") {
    api_url = "https://app.agilebrain.com";
    instance = axios.create({
        baseURL: `${api_url}/flex360api4/`
    });
} else if (hostname === "assessment5.agilebrain.com") {
    api_url = "https://app.agilebrain.com";
    instance = axios.create({
        baseURL: `${api_url}/flex360api5/`
    });
} else if (hostname === "localhost" || hostname === "dev-prototype.leadingindicator.com") {
    api_url = "https://development.leadingindicator.com";
    instance = axios.create({
        baseURL: `${api_url}/flex360api/`
    });
} else if (hostname === "assessmenttest.leadingindicator.com") {
    api_url = "https://qaapp.leadingindicator.com";
    instance = axios.create({
        baseURL: `${api_url}/flex360api2/`
    });
} else if (hostname === "assessment.leadingindicator.com") {
    api_url = "https://app.leadingindicator.com";
    instance = axios.create({
        baseURL: `${api_url}/flex360api/`
    });
} else if (hostname === "assessment2.leadingindicator.com") {
    api_url = "https://app.leadingindicator.com";
    instance = axios.create({
        baseURL: `${api_url}/flex360api2/`
    });
} else if (hostname === "assessment3.leadingindicator.com") {
    api_url = "https://app.leadingindicator.com";
    instance = axios.create({
        baseURL: `${api_url}/flex360api3/`
    });
} else if (hostname === "assessment4.leadingindicator.com") {
    api_url = "https://app.leadingindicator.com";
    instance = axios.create({
        baseURL: `${api_url}/flex360api4/`
    });
} else {
    api_url = "https://development.leadingindicator.com";
    instance = axios.create({
        baseURL: `${api_url}/flex360api/`
    });
}

console.log(process.env);


instance.defaults.headers.get['Content-Type'] = "application/json";

export default instance;
